import {ContactMessageDb, getContactMessageCollectionPath} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {firebaseFirestore} from '../../config/firebase';

export default function getContactMessageCollection(): CollectionReference<ContactMessageDb> {
  return collection(firebaseFirestore, getContactMessageCollectionPath()) as CollectionReference<ContactMessageDb>;
}
